"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationTree = void 0;
const Book_1 = require("./Book");
const ScriptureTreeObject_1 = require("./ScriptureTreeObject");
const iteratorUtil_1 = require("./iteratorUtil");
const mathUtil_1 = require("./mathUtil");
class TranslationTree extends ScriptureTreeObject_1.ScriptureTreeObject {
    constructor(data) {
        // Translation is the top level. There is no parent.
        super(data, null);
    }
    get firstBook() {
        return new Book_1.BookTree(this.data.books[0], this);
    }
    get lastBook() {
        return new Book_1.BookTree(this.data.books[this.data.books.length - 1], this);
    }
    get tid() {
        return this.data.tid;
    }
    get name() {
        return this.data.name;
    }
    get abbreviation() {
        return this.data.abbreviation;
    }
    get language() {
        return this.data.language;
    }
    get year() {
        return this.data.year;
    }
    dump() {
        return {
            tid: this.tid,
            name: this.name,
            abbreviation: this.abbreviation,
            language: this.language,
            year: this.year,
            fromVid: this.firstBook.firstChapter.firstVerse.fromVid,
            toVid: this.lastBook.lastChapter.lastVerse.toVid,
        };
    }
    /**
     * Get the IDs of all books in this translation.
     */
    get bookIds() {
        return this.data.books.map((book) => book.bid);
    }
    /**
     * Find a specific book by ID.
     */
    getBookById(bid) {
        const data = this.data.books.find((book) => book.bid === bid);
        return data ? new Book_1.BookTree(data, this) : null;
    }
    /**
     * Find a specific book by name.
     */
    getBookByName(name) {
        const data = this.data.books.find((book) => book.name === name);
        return data ? new Book_1.BookTree(data, this) : null;
    }
    /**
     * Get the verse with the exact ID (or for compound verses, a verse covering this ID).
     */
    getVerseById(vid) {
        return ((0, iteratorUtil_1.find)(this.iterateVerses(), (v) => v.fromVid <= vid && v.toVid >= vid) ||
            null);
    }
    /**
     * Get all verses in this translation that overlap with the given range of verse IDs.
     */
    getVersesById(fromVid, toVid) {
        return Array.from((0, iteratorUtil_1.filter)(this.iterateVerses(), (v) => (0, mathUtil_1.hasOverlap)(fromVid, toVid, v.fromVid, v.toVid)));
    }
    *iterateBooks(reverse = false) {
        const it = reverse ? this.data.books.slice().reverse() : this.data.books;
        for (const bookData of it) {
            yield new Book_1.BookTree(bookData, this);
        }
    }
    *iterateChapters(reverse = false) {
        for (const book of this.iterateBooks(reverse)) {
            yield* book.iterateChapters(reverse);
        }
    }
    *iterateVerses(reverse = false) {
        for (const chapter of this.iterateChapters(reverse)) {
            yield* chapter.iterateVerses(reverse);
        }
    }
    getVersesStartingAtId(vid, limit) {
        return Array.from((0, iteratorUtil_1.filter)(this.iterateVerses(), (v) => v.toVid >= vid, limit));
    }
    getVersesEndingAtId(vid, limit) {
        return Array.from((0, iteratorUtil_1.filter)(this.iterateVerses(true), (v) => v.fromVid <= vid, limit)).reverse();
    }
}
exports.TranslationTree = TranslationTree;
